import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NxAccordionModule } from '@aposin/ng-aquila/accordion';
import { NxGridModule } from '@aposin/ng-aquila/grid';
import { NxDataDisplayModule } from '@aposin/ng-aquila/data-display';
import { NxCopytextModule } from '@aposin/ng-aquila/copytext';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NxDropdownModule } from '@aposin/ng-aquila/dropdown';
import { NxInputModule } from '@aposin/ng-aquila/input';
import { NxFormfieldModule } from '@aposin/ng-aquila/formfield';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxTableModule } from '@aposin/ng-aquila/table';
import { NxListModule } from '@aposin/ng-aquila/list';
import { NxSwipebarModule } from '@aposin/ng-aquila/swipebar';
import { NxCardModule } from '@aposin/ng-aquila/card';
import { NxCheckboxModule } from '@aposin/ng-aquila/checkbox';
import { TextFieldModule } from '@angular/cdk/text-field';
import { NxModalModule } from '@aposin/ng-aquila/modal';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { MyDateAdapter } from "@shared/helpers/date.adapter";
import { NxDateAdapter, NX_DATE_FORMATS, NxDatefieldModule } from '@aposin/ng-aquila/datefield';
import { NxMomentDateModule } from '@aposin/ng-aquila/moment-date-adapter';
import { NxRadioModule } from '@aposin/ng-aquila/radio-button';
import { SummaryPopupComponent } from "../../../../popup/summary-popup/summary-popup.component";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Store, Select } from '@ngxs/store';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import moment from "moment";
import { formatDate } from '@angular/common';

import {
  DOWNLOAD_PDF,
  GENERATE_QUOTATION,
  GET_DOCUMENT_LOV,
  ISSUANCE_CALCULATE_PREMIUM_SUMMARY,
  RESET_DRAFT_DETAILS,
  RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ,
  RESET_SUMMARY_MESSAGE,
  SAVE_PAYMENT,
  SEND_TO_JPJ,
  SET_CURRENT_STEP,
  SET_JPJ_STATUS_SENT,
  STORE_ISSUANCE_SUMMARY,
  STORE_PAYMENT_INFO,
  STORE_ROAD_TAX_PAYABLE,
  STORE_SHOWED_ONE_ALLIANZ_POP_UP,
  SEARCH_ORIXCompanyInfo,
  CALCULATE_PREMIUM_NCD,
  GET_PRODUCT_LIST,
  EDIT_CUSTOMER_PARTNER,
  SET_EINVOICE_CONSENT_IND
} from "@store/sat-motor/sat-motor.action";
import { SharedModule } from '@shared/shared.module';
import { OneAllianzMessageComponent } from '@shared/components/modal/one-allianz-message/one-allianz-message.component';
import { PaymentDetailsComponent } from '@shared/components/payment-details/payment-details.component';
import { UpsellProductComponent } from '@shared/components/upsell-product/upsell-product.component';
import { UserResponse } from "@interfaces/user";
import { CoverageSummaryComponent } from '@shared/components/coverages/coverage-summary/coverage-summary.component';
import { OkMessageComponent } from '@shared/components/modal/ok-message/ok-message.component';
import { SatMotorState } from '@store/sat-motor/sat-motor.state';
import { ScrollToError } from '@shared/classes/scroll-to-error';
import { EndorsementNarrationComponent } from "@shared/components/endorsement-narration/endorsement-narration.component";
import { PaymentComponent } from "@shared/components/payment/payment.component";
import { UploadDocumentComponent } from '@shared/components/upload-document/upload-document.component';
import { RoadTaxPayableComponent } from '@shared/components/road-tax-payable/road-tax-payable.component';
import { PaymentInformationComponent } from '@shared/components/payment-information/payment-information.component';
import { RemoveCommaPipe } from '@shared/pipes/remove-comma/remove-comma.pipe';
import { SimpleModalComponent } from '@shared/components/modal/simple-modal/simple-modal.component';
import { ConfirmationModalComponent } from '@shared/components/modal/confirmation-modal/confirmation-modal.component';
import { WarningPopupComponent } from '@shared/components/modal/warning-popup/warning-popup.component';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { MessagePromptModalComponent } from '@shared/components/modal/message-prompt-modal/message-prompt-modal.component';
import { AccessConfig, ButtonAccessConfig } from '@shared/helpers/sat-menu-access-config';
import { MenuAccessService } from '@shared/services/sat-menu-access/menu-access.service';
import { ErrorModalComponent } from '@shared/components/modal/error-modal/error-modal.component';
import { RESET_ERROR_MESSAGE, SET_ERROR_FLAG, SET_ERROR_MESSAGE } from '@store/exception/error.action';
import { ErrorState, ErrorModel } from '@store/exception/error.state';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [
    NxAccordionModule,
    NxGridModule,
    NxDataDisplayModule,
    NxCopytextModule,
    NxButtonModule,
    NxIconModule,
    NxDropdownModule,
    NxInputModule,
    NxFormfieldModule,
    NxHeadlineModule,
    NxTableModule,
    NxListModule,
    NxSwipebarModule,
    NxCardModule,
    NxCheckboxModule,
    TextFieldModule,
    NxModalModule,
    NxDatefieldModule,
    //NxMomentDateModule,
    NxRadioModule,
    SharedModule,
    PaymentDetailsComponent,
    UpsellProductComponent,
    CoverageSummaryComponent,
    OkMessageComponent,
    EndorsementNarrationComponent,
    PaymentComponent,
    RoadTaxPayableComponent,
    PaymentInformationComponent
  ],
  providers: [
    { provide: NxDateAdapter, useClass: MyDateAdapter },
    { provide: NX_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss'
})
export class SummaryComponent implements OnInit, AfterViewInit {

  @Select(SatMotorState.motorActionType) actionType$;

  @Select(ErrorState.error) error$: Observable<any>;

  @ViewChild('paymentSectionStart') paymentSectionStart!: ElementRef;

  isIssuance: boolean = false;
  isEndorsement: boolean = false;
  isEnquiry: boolean = false;
  isRTP: boolean = false;

  progressType: any;
  userInfo: any;
  agentData: any;
  issuanceInfo: any = {};
  clientClaimHistory: any;
  vehicleClaimHistory: any;
  rtpPolicy: any;
  premiumInfo: any;
  coverageInfo: any;
  cpData: any;
  lov: any;
  isProgressTypeCN: boolean = false;
  isProgressTypeENDST: boolean = false;
  isProgressTypeRTP: boolean = false;

  showAgentInfo: boolean = false;
  showIssuanceInfo: boolean = false;
  showCustomerPartner: boolean = false;
  showReferralDetails: boolean = false;
  showCoverage: boolean = false;
  showHistoricalClaim: boolean = false;
  showPremiumInformation: boolean = false;
  showReferCase: boolean = false;
  showPayment: boolean = false;
  showUpsellProduct: boolean = false;
  showPaymentInformation: boolean = false;
  showPaymentDetails: boolean = false;
  showChecklist: boolean = false;
  showRenewalAssistant: boolean = false;
  showEndorsementNarration: boolean = false;
  showRoadTaxPayable: boolean = false;
  showEndorsementErrMessage: boolean = false;
  showEditButton: boolean = true;
  generateQuotationIsDone: boolean = false;
  isCCentric: boolean = false;
  isNonEligibleOneAllianz: boolean = false;
  blocked: boolean = false;
  closePopupAction: string = '';
  referralForm: FormGroup;
  referCaseForm: FormGroup;
  salesmanIdForm: FormGroup;
  previousPolicyDetails: any;
  requoteQuotation: any;
  renewalAssistanceInd: any;
  cnoteType: any;
  renewalAssistanceDetails: any;

  dialogRef?: NxModalRef<any>;
  okMessageModal?: NxModalRef<OkMessageComponent>;
  simpleModal?: NxModalRef<SimpleModalComponent>;
  confirmMessageModal?: NxModalRef<any>;
  warningPopupModal?: NxModalRef<WarningPopupComponent>;
  summaryForm: FormGroup;
  infoMessageModal?: NxModalRef<SimpleModalComponent>;

  @Select(SatMotorState.premiumCalculationSummary) premiumCalculationSummary$: Observable<SatMotorState>;

  alimCustomerEligible: boolean;
  hasShowedOneAllianzPopUp: boolean;
  oneAllianzModal?: NxModalRef<OneAllianzMessageComponent>;
  paymentList: any = [];
  payment: any;
  roadTaxPayable: any;
  paymentInformation: any;
  numberFmt: any;
  motorPC: any;
  lovproductConfig: any;
  productAccessListData: any;
  lovPC: string;
  lovGeo: any;
  emailCheck : any;
  edocConsentInd: boolean = false;
  eInvoiceConsentInd : boolean;
  isUpdatePayment: any;
  isSingleAgent: boolean = false;
  isCancelReplaceCoverNote: boolean = false;
  renewalAssistanceCheckbox: boolean = false;
  selection: any;
  opportunityId: any;
  dataORIXLeasingLov: any;
  effectiveDateMessage: any;
  isCreatedByCcUser: boolean = false;
  issueOnQuotation: boolean = false;
  showSalesmanID: boolean = false;

  NCD_WO_NOTIFICATION = [
    "CFO000", "CFO014", "CFO016", "CFO017", "CFO030", "CFO044", "CFO051", "CFO057", "CFO060", "CFO062", 
    "CFO063", "CFO067", "CFO078", "CFO079", "CFO080", "CFO081", "CFO088", "CFO089", "CFO092", "CFO096",

  ];

  constructor(
    private dialogService: NxDialogService,
    public store: Store,
    private router: Router,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private accessService: MenuAccessService
  ) {
    this.numberFmt = new RemoveCommaPipe();
    this.referralForm = this.fb.group({
      referralId: ['',]
    });

    this.referCaseForm = this.fb.group({
      waiveLoadInd: [{ value: false, disabled: true }],
      waiveExcessInd: [{ value: false, disabled: true }],
      underwritingInd: [false],
      remarks: ['']
    });
    this.salesmanIdForm = this.fb.group({
      frStaffNo: ['',]
    });
    this.summaryForm = this.fb.group({});
  }

  renewalAssistanceForm = new FormGroup({
    autoRenewalInd: new FormControl(false),
    creditCardType: new FormControl(''),
    creditCardNo: new FormControl(''),
    creditCardExpMonth: new FormControl(''),
    creditCardExpYear: new FormControl(''),
    creditCardHolderName: new FormControl(''),
    termsOfUse: new FormControl({ value: false, disabled: true }),
    autoRenewalStartDt: new FormControl('')
  });

  monthList = [
    { code: '1', name: '01' },
    { code: '2', name: '02' },
    { code: '3', name: '03' },
    { code: '4', name: '04' },
    { code: '5', name: '05' },
    { code: '6', name: '06' },
    { code: '7', name: '07' },
    { code: '8', name: '08' },
    { code: '9', name: '09' },
    { code: '10', name: '10' },
    { code: '11', name: '11' },
    { code: '12', name: '12' },
  ];

  yearList = [
    { code: '2024', name: '2024' },
    { code: '2025', name: '2025' },
    { code: '2026', name: '2026' },
    { code: '2027', name: '2027' }
  ];

  paymentModeList = [
    { code: 'MASTER', name: 'MASTER' },
    { code: 'VISA', name: 'VISA' }
  ];

  ngOnInit() {
    window.scroll({ top: 0, left: 0, behavior: 'instant' });

    const errorCode = this.store.selectSnapshot<any>((state) => state.ErrorState?.detail?.code);
    if (errorCode) {
      this.blocked = errorCode !== 200 || errorCode === 999;
    }

    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.previousPolicyDetails = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState.previousPolicyDetails);
    this.cnoteType = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step1?.issuance?.issuance?.cnoteType);
    this.edocConsentInd = this.store.selectSnapshot<boolean>(state => state.SatMotorState.motor.step1?.issuance?.pdpa?.consentDetails?.edocConsentInd);
    this.eInvoiceConsentInd = this.store.selectSnapshot<boolean>(state => state.SatMotorState.motor.step1?.issuance?.pdpa?.consentDetails?.einvoiceConsentInd);
    this.isUpdatePayment = this.store.selectSnapshot<any>(state => state.SatMotorState.isUpdatePayment);
    this.isCCentric = this.store.selectSnapshot<any>((state) => state.SatMotorState.opportunityId);
    this.opportunityId = this.store.selectSnapshot<any>((state) => state.SatMotorState.opportunityId);
    this.agentData = this.store.selectSnapshot(SatMotorState.motorAgentDetail);
    this.isSingleAgent = this.store.selectSnapshot<any>((state) => state.SatMotorState.isSingleAgent);
    this.requoteQuotation = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState.requoteQuotation);
    this.renewalAssistanceInd = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState?.motor?.step1?.agentDetail?.enableRenewalAssistance);
    this.renewalAssistanceDetails = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState?.motor?.step4?.summary?.renewalAssistance);
    this.dataORIXLeasingLov = this.store.selectSnapshot<any>((state) => state.SatMotorState?.lov?.searchORIXCompany);
    this.effectiveDateMessage = this.store.selectSnapshot<any>((state) => state.SatMotorState.summaryMessage);
    this.isCreatedByCcUser = this.store.selectSnapshot<boolean>((state) => state.SatMotorState?.isCreatedByCcUser);
    this.issueOnQuotation = this.userInfo?.issueOnQuotation;

    this.actionType$.subscribe((state) => {
      if (state) {
        this.isIssuance = state.isIssuance;
        this.isEndorsement = state.isEndorsement;
        this.isEnquiry = state.isEnquiry;
        this.isRTP = state.isRTP;
      }
    });

    this.error$.subscribe((err) => {
      console.log(err);
      if (err?.code)
        this.blocked = (err?.code !== 200 || err?.code === 999);
    });
    
    this.setStep();
    this.lov = this.store.selectSnapshot<any>((state) => state.SatMotorState.lov);

    this.showComponents();
    this.setProgressType();

    if (this.isIssuance) {
      this.retrieveIssuanceData();
    }

    if (this.isRTP) {
      this.retrieveRTPData();
    }

    if (this.isEndorsement) {
      this.retrieveEndorsementData();
    }

    if(this.renewalAssistanceInd){
      if(!this.renewalAssistanceForm.controls.autoRenewalInd.value){
        this.populateRenewalAssistanceForm();
      }
      this.showRenewalAssistant = true;
      if(this.isUpdatePayment){
        this.disableRenewalAssistanceForm();
      }
    }else{
      this.showRenewalAssistant = false;
    }

    if (this.previousPolicyDetails || this.requoteQuotation) {
      const latestPremiumData = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote?.riskList[0]?.coverList[0] ?? null);

      if(this.previousPolicyDetails && !latestPremiumData){
        this.premiumInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coverageType);
        this.premiumInfo = {
          ...this.premiumInfo,
          stamp: this.previousPolicyDetails.stamp,
          premiumDueRounded: this.previousPolicyDetails.premiumDueRounded
        };
      }else if(this.requoteQuotation){
        this.premiumInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote);
        this.premiumInfo = {
          ...this.premiumInfo,
          ncdPercentage: this.premiumInfo?.riskList[0]?.coverList[0]?.ncdPercentage,
          ncdAmount: this.premiumInfo?.riskList[0]?.coverList[0]?.ncdAmount,
          rebatePct: this.premiumInfo?.riskList[0]?.coverList[0]?.rebatePct,
          rebateAmt: this.premiumInfo?.riskList[0]?.coverList[0]?.rebateAmt
        };        
      if(this.premiumInfo?.oppurtunityId && this.premiumInfo?.proposalNo){
        this.generateQuotationIsDone = true;
      }
      }
    }

    if(this.isCCentric && !this.generateQuotationIsDone){
      this.isCCentric = true;
    }else{
      this.isCCentric = false;
    }

    if(this.isUpdatePayment) {
      this.updatePaymentDisableField();
    }

    this.isCancelReplaceCoverNote = this.store.selectSnapshot<any>(state => state.SatMotorState?.isCancelReplaceCoverNote);

    this.saveSummaryStep();

  }

  ngAfterViewInit() {
    if (this.isUpdatePayment) {
      setTimeout(() => {
        this.paymentSectionStart.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }

  setStep() {
    let step;
    if (this.isRTP) {
      step = 2;
    } else if (this.cnoteType == "ENDT") {
      step = 3;
    } else {
      if ((this.agentData?.bancaAgent || this.agentData?.sundriesAgent)) {
        step = 5;
      } else {
        step = 4;
      }
    }
    this.store.dispatch(new SET_CURRENT_STEP(step));
  }
  
  retrieveIssuanceData() {
    let step4Summary = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step4?.summary);
    const cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
    this.alimCustomerEligible = this.store.selectSnapshot<boolean>((state) => state.SatMotorState.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0]?.alimCustomerEligible);
    this.hasShowedOneAllianzPopUp = this.store.selectSnapshot<boolean>(state => state.SatMotorState.data?.hasShowedOneAllianzPopUp);
    const activeQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step1?.activeQuotation ?? null);
    const previousPolicyDetails = this.store.selectSnapshot<any>(state => state.SatMotorState.previousPolicyDetails ?? null);
    const retrieveQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState.retrieveQuotation ?? null);
    const vehicleDetails = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step3.coverage.vehicleDetails);
    let generateQuotationData = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data);
    let oneAllianzData = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step2.oneAllianzData ?? null);
    let oldData = null;
    let isThirdParty = false;
    let step1CnoteType = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step1?.issuance?.issuance?.cnoteType);

    if (((activeQuotation && retrieveQuotation) || previousPolicyDetails) && step1CnoteType != "NWTR") {
      oldData = activeQuotation ? activeQuotation.cngeNote : previousPolicyDetails;
    }

    if (cngeNote?.riskList?.length > 0 &&
      cngeNote.riskList[0]?.coverList?.length > 0 &&
      cngeNote.riskList[0].coverList[0]?.coverCode === '20') {
      isThirdParty = true;
    }

    if (oneAllianzData && !this.hasShowedOneAllianzPopUp && !isThirdParty) {
      if (oneAllianzData.oriAlimCustomerIndi === 'YES' && oneAllianzData.alimCustomerIndi === 'NO' && this.alimCustomerEligible) {
        this.openPopupOneAllianz(true);

      } else if (oneAllianzData.oriAlimCustomerIndi === 'YES' && oneAllianzData.alimCustomerIndi === 'YES'&& this.alimCustomerEligible) {
        this.openPopupOneAllianz(false);

      } else if ((oneAllianzData.oriAlimCustomerIndi === 'NO' || !oneAllianzData.oriAlimCustomerIndi) && oneAllianzData.alimCustomerIndi === 'YES' && this.alimCustomerEligible) {
        this.openPopupOneAllianz(false);

      } else {
        if (this.effectiveDateMessage) {
          this.okMessageModal = this.dialogService.open(OkMessageComponent, {
            disableClose: true,
            width: '400px',
            data: {
              message: this.effectiveDateMessage
            }
          });
          this.store.dispatch(new RESET_SUMMARY_MESSAGE());
        }
      }
    } else {
      if (this.effectiveDateMessage) {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: this.effectiveDateMessage
          }
        });
        this.store.dispatch(new RESET_SUMMARY_MESSAGE());
      }
    }

    //Agent Information
    const agentDetail = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step1.agentDetail);
    this.agentData = {
      ...agentDetail,
      issuedDate: new Date(),
      issuedBy: this.userInfo.userId
    };

    //Issuance Information
    if (oldData) {
      this.issuanceInfo = this.getIssuanceData(oldData);
    } else {
      this.issuanceInfo = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step1.issuance);
      this.issuanceInfo = {
        ...this.issuanceInfo,
        issuance: {
          ...this.issuanceInfo.issuance,
          vehicleNo: vehicleDetails.vehicleNo,
          ...(generateQuotationData && {
            equotationNo: generateQuotationData.proposalNo,
            equotationCreatedDate: generateQuotationData.proposalDate
          })
        }
      };
    }

    //Customer Partner
    this.cpData = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step2);

    //Coverage
    this.coverageInfo = this.store.selectSnapshot(SatMotorState.motorStep3Coverage);
    let vehicleDetail = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step3.coverage.vehicleDetails);
    const fCoverageLoadRN = this.store.selectSnapshot<any>((state) => state.SatMotorState.fCoverageLoadRN)

    if (oldData?.riskList[0]?.makeModelDesc && !fCoverageLoadRN) {
      this.coverageInfo = {
        ...this.coverageInfo,
        coverage: {
          ...this.coverageInfo.coverage,
          vehicleDetails: {
            ...this.coverageInfo.coverage.vehicleDetails,
            makeModelDesc: oldData?.riskList[0]?.makeModelPrintInd === "N" ? vehicleDetail?.makeModelDesc : oldData?.riskList[0]?.makeModelDesc,
          }
        }
      };
    }
    else if (activeQuotation?.cngeNote?.riskList[0] && !fCoverageLoadRN) {
      this.coverageInfo = {
        ...this.coverageInfo,
        coverage: {
          ...this.coverageInfo.coverage,
          vehicleDetails: {
            ...this.coverageInfo.coverage.vehicleDetails,
            makeModelDesc: activeQuotation.cngeNote.riskList[0]?.makeModelPrintInd === "N" ? vehicleDetail?.makeModelDesc : activeQuotation.cngeNote.riskList[0]?.makeModelDesc,
          }
        }
      };
    }

    if (this.issuanceInfo.issuance.cnoteType) { //PrevSumInsured CR
      if (this.issuanceInfo?.issuance?.cnoteType === 'RN') {
        console.log('PrevSumInsured:', this.coverageInfo?.coverage?.coverageType?.prevSumInsured ?? 'N/A');
      }

      this.coverageInfo = {
        ...this.coverageInfo,
        coverage: {
          ...this.coverageInfo.coverage,
          coverageType: {
            ...this.coverageInfo.coverage.coverageType,
            cnoteType: this.issuanceInfo.issuance.cnoteType,
          }
        }
      };
    }

    //Historical claims
    this.clientClaimHistory = cngeNote?.claimCnt ?? '0';
    this.vehicleClaimHistory = cngeNote?.vehClaimCount ?? '0';

    //Premium Information
    this.loadPremiumSummaryData();

    //ReferralId and Remarks populate
    this.populateReferralRemarks(step4Summary);

    //Refer Case
    this.updateRemarksValidator();
    this.subscribeToCheckboxChanges();

    this.store.dispatch(new GET_DOCUMENT_LOV({
      lob: "MT",
      userId: this.userInfo.userId,
      productCode: this.issuanceInfo.issuance.productCode,
      productType: "",
      type: "SATMTCNDOCTYPE"
    }));

    if (this.userInfo.callCenter) {
      this.getPaymentData(step4Summary);
    }

    //Map ORIX fields
    if (this.coverageInfo.coverage.vehicleDetails.leasingCompany && (!this.dataORIXLeasingLov || this.dataORIXLeasingLov === ""))
      this.store.dispatch(new SEARCH_ORIXCompanyInfo({ agentCode: this.coverageInfo.coverage.coveragePremium.cngeNote.mkagAgent.agentCode, 
        loanCompany: this.coverageInfo.coverage.vehicleDetails.vehicleLoanCompany, loanType: this.coverageInfo.coverage.vehicleDetails.vehicleLoanType, 
        vehType: this.coverageInfo.coverage.coveragePremium.cngeNote.productCode, eInvoiceInd: this.coverageInfo.coverage.coveragePremium.cngeNote.einvoiceConsentInd})).subscribe((state) => {        
          if (state.SatMotorState.lov.searchORIXCompany){
            this.lov = {
              ...this.lov,
              searchORIXCompany: state.SatMotorState?.lov?.searchORIXCompany,
            };
            this.dataORIXLeasingLov = state.SatMotorState?.lov?.searchORIXCompany;
          }
        });
  }

  getIssuanceData(cngeNote: any): any {
    this.issuanceInfo = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step1.issuance);
    let risk = cngeNote.riskList[0];
    let latestData = this.issuanceInfo && this.issuanceInfo.issuance;

    const issuanceInfo = {
      issuance: {
        productCode: cngeNote.productCode,
        vehicleNo: cngeNote.vehicleNo ?? risk.vehicleNo,
        cnoteType: cngeNote.cnoteType,
        prevPolicyNo: cngeNote.previousPolicyNo,
        effectiveDate: this.issuanceInfo?.issuance?.effectiveDate ?? cngeNote.effectiveDate,
        expiryDate: this.issuanceInfo?.issuance?.expiryDate ?? cngeNote.expiryDate,
        equotationNo: latestData?.equotationNo ?? latestData?.proposalNo ?? cngeNote.proposalNo,
        equotationCreatedDate: latestData?.equotationCreatedDate ?? cngeNote.proposalDate,
        eCoverNoteNo: cngeNote.cnoteNo,
        jpjStatus: risk.jpjStatus,
        jpjMessage: cngeNote.jpjMessage,
      },
      pdpa: {
        consentDetails: {
          edocConsentInd: this.issuanceInfo?.pdpa?.consentDetails?.edocConsentInd,
          einvoiceConsentInd: this.issuanceInfo?.pdpa?.consentDetails?.einvoiceConsentInd,
          emarketingConsentInd: this.issuanceInfo?.pdpa?.consentDetails?.emarketingConsentInd
        },
      },
    };

    return issuanceInfo;
  }

  populateReferralRemarks(data) {
    if (!data || !data.referCaseData) {
      const cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
      if (cngeNote) {
        data = null;
        let remarks = (cngeNote.referRemarkList && cngeNote.referRemarkList.length > 0) ? cngeNote.referRemarkList[0].referRemark : null;
        data = {
          referralId: cngeNote.agentReferId,
          frStaffNo: cngeNote.frStaffNo,
          referCaseData: {
            waiveLoadInd: cngeNote.referWaiveLoad,
            waiveExcessInd: cngeNote.referWaiveExcess,
            underwritingInd: cngeNote.referUnderWriting,
            remarks: remarks
          }
        }
      }
    }

    if (data) {
      if (data.referralId !== null && data.referralId !== undefined && data.referralId !== '') {
        this.referralForm.patchValue({
          referralId: data.referralId
        });
      }
      if (data.frStaffNo !== null && data.frStaffNo !== undefined && data.frStaffNo !== '' && this.showSalesmanID) {
        this.salesmanIdForm.patchValue({
          frStaffNo: data.frStaffNo
        });
      }
      if (data.referCaseData) {
        const referCaseData = data.referCaseData;

        const formValue: any = {
          waiveLoadInd: referCaseData.waiveLoadInd,
          waiveExcessInd: referCaseData.waiveExcessInd,
          underwritingInd: referCaseData.underwritingInd
        };

        if (referCaseData.remarks !== null && referCaseData.remarks !== undefined && referCaseData.remarks !== '') {
          formValue.remarks = referCaseData.remarks;
        }

        this.referCaseForm.patchValue(formValue);
      }
    }
  }

  retrieveEndorsementData() {
    const endtVehiclePolicyData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtVehicleData);
    const endtPreviousVehiclePolicyData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtPreviousVehicleData);

    let step3Summary = this.store.selectSnapshot<any>((state) => state.SatMotorState.endorsement?.step2?.endorsementDetails);
    this.hasShowedOneAllianzPopUp = this.store.selectSnapshot<boolean>(state => state.SatMotorState.data?.hasShowedOneAllianzPopUp);
    const activeQuotation = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step1?.activeQuotation ?? null);
    const previousPolicyDetails = this.store.selectSnapshot<any>(state => state.SatMotorState.previousPolicyDetails ?? null);

    //Agent Information
    const agentDetail = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step1.agentDetail);
    console.log('agentDetail:' + agentDetail); //undefined
    this.agentData = {
      ...agentDetail,
      agentCode: endtVehiclePolicyData?.mkagAgent?.agentCode,
      name: endtVehiclePolicyData?.mkagAgent?.name,
      issuedDate: endtVehiclePolicyData?.cnoteDate,
      issuedBy: endtVehiclePolicyData?.issueBy
    };

    //Issuance Information
    this.issuanceInfo = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step1.issuance);

    //Customer Partner

    let eInvoiceCustomerPartner = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step2.endorsementDetails.eInvoiceCustomerPartner);

    if (eInvoiceCustomerPartner) {
      this.cpData = eInvoiceCustomerPartner;

    } else if (!eInvoiceCustomerPartner && endtVehiclePolicyData) {
      let customerPartnerData = endtVehiclePolicyData?.clientPartner;
      this.cpData = {
        ...customerPartnerData,
        email: endtVehiclePolicyData?.clientPartner?.clientEmail,
      };
    }

    //Coverage
    let endorsementDetails = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step2.endorsementDetails); //need to check
    console.log('summary endorsementDetails:', endorsementDetails);

    if (!this.coverageInfo) {
      this.getCoverageFromPolicy(endtVehiclePolicyData);
    }

    let coverageInfoTemp = this.coverageInfo;

    if (endorsementDetails.vehicleDetails) {
      this.coverageInfo = {
        ...coverageInfoTemp,
        vehicleDetails: endorsementDetails.vehicleDetails,
      };
    } else if (endorsementDetails.extraCover) { //need to fix to match with rtp and issuance for coverageInfo
      this.coverageInfo = {
        ...coverageInfoTemp,
        extraCover: endorsementDetails.extraCover,
      };
    } else if (endorsementDetails.vehicleSumInsured) { //need to fix to match with rtp and issuance for coverageInfo
      this.coverageInfo = {
        ...coverageInfoTemp,
        vehicleSumInsured: endorsementDetails.vehicleSumInsured,
      };
    } else if (endorsementDetails.ncd) { //need to fix to match with rtp and issuance for coverageInfo
      this.coverageInfo = {
        ...coverageInfoTemp,
        ncd: endorsementDetails.ncd,
      };
    } else if (endorsementDetails.namedDriver) { //need to fix to match with rtp and issuance for coverageInfo
      this.coverageInfo = {
        ...coverageInfoTemp,
        namedDriver: endorsementDetails.namedDriver,
      };
    }

    console.log('summary this.coverageInfo:', this.coverageInfo);

    //Historical claims
    this.clientClaimHistory = endtPreviousVehiclePolicyData?.claimCnt ?? '0';
    this.vehicleClaimHistory = endtPreviousVehiclePolicyData?.vehClaimCount ?? '0'; //no data for now

    //Premium Information
    this.premiumInfo = endtVehiclePolicyData?.riskList[0]?.coverList[0];
    this.premiumInfo = {
      ...this.premiumInfo,
      stamp: endtVehiclePolicyData.stamp,
      premiumDueRounded: endtVehiclePolicyData.premiumDueRounded
    };

    //ReferralId and Remarks populate
    this.populateReferralRemarks(step3Summary);

    //Refer Case
    this.updateRemarksValidator();
    this.subscribeToCheckboxChanges();

    this.store.dispatch(new GET_DOCUMENT_LOV({
      lob: "MT",
      userId: this.userInfo.userId,
      productCode: this.issuanceInfo.issuance.productCode,
      productType: "",
      type: "SATMTCNDOCTYPE"
    }));
  }

  retrieveRTPData() {
    this.rtpPolicy = this.store.selectSnapshot<any>(state => state.SatMotorState.rtp?.step1?.rtpPolicy?.data?.cngeNoteDto);
    let vehicleNo = this.store.selectSnapshot<any>(state => state.SatMotorState.rtp?.step1?.issuance?.issuance?.vehicleNo);

    if (this.rtpPolicy) {
      this.agentData = { ...this.rtpPolicy.mkagAgent, issuedDate: this.rtpPolicy.cnoteDate, issuedBy: this.userInfo.userId };

      //Declaration issuance
      let issuanceData = {
        productCode: this.rtpPolicy.productCode,
        productName: this.rtpPolicy.productName,
        vehicleNo: this.rtpPolicy.vehicleNo ?? vehicleNo,
        coverNoteType: 'ROAD TAX PURPOSE',
        policyNo: this.rtpPolicy.policyNo,
        effectiveDate: this.rtpPolicy.effectiveDate,
        expiryDate: this.rtpPolicy.expiryDate,
        eCoverNoteNo: this.rtpPolicy.cnoteNo,
      }

      this.issuanceInfo = {
        issuance: issuanceData
      }

      //Customer Partner
      this.cpData = this.rtpPolicy.clientPartner;


      //Coverage
      if (!this.coverageInfo) {
        this.getCoverageFromPolicy(this.rtpPolicy);
      }

      //Premium Calculation
      this.premiumInfo = this.rtpPolicy?.riskList[0]?.coverList[0];
      this.premiumInfo = {
        ...this.premiumInfo,
        stamp: this.rtpPolicy.stamp,
        premiumDueRounded: this.rtpPolicy.premiumDueRounded
      };
    }

      //Product Access Config
      this.store.dispatch(new GET_PRODUCT_LIST({ lob: 'MT', agentCode: this.agentData.agentCode })).subscribe(state => {
        this.lov = {
          ...this.lov,
          productAccessConfigList: state.SatMotorState?.lov?.productAccessConfigList,
        };
      });

    this.clientClaimHistory = this.rtpPolicy.claimCnt ?? '0';
    this.vehicleClaimHistory = this.rtpPolicy.vehClaimCount ?? '0';
  }

  loadPremiumSummaryData() {
    let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote);
    const premiumInfo = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote?.riskList[0]?.coverList[0] ?? null);

    if (premiumInfo && cngeNote) {
      this.premiumInfo = {
        ...premiumInfo,
        stamp: cngeNote.stamp,
        premiumDueRounded: cngeNote.premiumDueRounded,
        grossPremium: cngeNote.grossPremium
      };

      if(this.opportunityId || this.isCreatedByCcUser) {
        this.premiumInfo.premiumDueRounded = cngeNote.cCentrixPremiumDueRounded;
      }
      this.updateReferState();
    }
  }

  getCoverageFromPolicy(policy) {
    let risk = policy.riskList[0];
    let coverList = risk.coverList[0];

    const coverageInfo = {
      vehicleDetails: risk,
      coverageDetails: coverList,
      driverNameDetails: this.getDriverListForRTPAndEndt(risk.cngeRiskDrvrDtoList, true),
      ehailingDriverDetails: this.getDriverListForRTPAndEndt(risk.cngeRiskDrvrDtoList, false),
      extraCoverPackageSummary: this.getExtraCoverage(coverList),
    };

    this.coverageInfo = coverageInfo;
  }

  getExtraCoverage(coverList: any) {
    if (!coverList || !coverList.subCoverList) {
      return {
        subCovPackageDesc: null,
        rahmahPackageList: [],
        topExtraCoverList: [],
        selectedExtraCoverList: [],
      };
    }

    const extraCoverPackage = coverList.subCoverList.map(cv => ({
      ...cv,
      description: cv.subCoverCodeDescription,
      selected: cv.selectedInd,
      enabled: cv.enableInd ?? false,
    }));

    let selectedExtraCoverList = extraCoverPackage.filter(o1 => o1.subCoverCode === 'A221' || o1.subCoverCode === '57' || o1.subCoverPrem > 0 || o1.subCoverPrem < 0);
    if(selectedExtraCoverList){
      selectedExtraCoverList.sort((a, b) => {
        return a.sequenceNumber - b.sequenceNumber;
      });
    }
    let rahmahPackageList = extraCoverPackage.filter(o1 => o1.subCovPackage && !o1.subCoverPrem);
  
    let topExtraCoverList = extraCoverPackage
      .filter(o1 => !o1.subCoverPrem)
      .filter(o1 => !rahmahPackageList.some(rp => rp.subCoverCode === o1.subCoverCode))
      .filter(o1 => !selectedExtraCoverList.some(rp => rp.subCoverCode === o1.subCoverCode)); 


      return {
        subCovPackageDesc: coverList.subCovPackageDesc ?? null,
        costInd: coverList.costInd,
        rahmahPackageList: rahmahPackageList,
        topExtraCoverList: topExtraCoverList,
        selectedExtraCoverList: selectedExtraCoverList
      };
  }

  getDriverListForRTPAndEndt(cngeRiskDrvrDtoList, isNormalDriver) {
    return cngeRiskDrvrDtoList?.filter(({ cngeRiskDrvrPkDto: { driverType } }) =>
      isNormalDriver ? driverType === 'NORM' : driverType === 'EHAIL'
    ).map(({ cngeRiskDrvrPkDto: { driverName }, driverId, driverAge }) => ({
      driverName,
      driverId,
      driverAge,
    })) || null;
  }

  getDriverListData(cngeRiskDrvrDtoList: any) {
    if (cngeRiskDrvrDtoList) {
      return cngeRiskDrvrDtoList.map(item => {
        return {
          driverName: item.cngeRiskDrvrPkDto.driverName,
          driverId: item.driverId,
          driverAge: item.driverAge
        };
      });
    }
    return null;
  }

  setProgressType() {
    if (this.isIssuance) {
      this.progressType = 'cn';
    }

    if (this.isRTP) {
      this.progressType = 'rtp';
    }

    if (this.isEndorsement) {
      this.progressType = 'endorsement';
    }
  }

  saveSummaryStep() {

    let summaryData = {
      agentData: this.agentData,
      issuanceInfo: this.issuanceInfo,
      customerPartnerDetails: this.cpData,
      referralId: this.referralForm?.get('referralId')?.value ?? null,
      coverageInfo: this.coverageInfo,
      clientClaimHistory: this.clientClaimHistory,
      vehicleClaimHistory: this.vehicleClaimHistory,
      premiumInfo: this.premiumInfo,
      referCaseData: this.referCaseForm.getRawValue(),
      renewalAssistance:  this.renewalAssistanceForm.getRawValue(),
      frStaffNo:  this.salesmanIdForm?.get('frStaffNo')?.value
    };

    console.log('Summary Data:', summaryData);
    this.store.dispatch(new STORE_ISSUANCE_SUMMARY(summaryData));

  }

  onBlurReferralId() {
    if (this.referralForm.invalid) {
      this.referralForm.markAllAsTouched();
    }
    if (this.referralForm.valid) {
      this.saveSummaryStep();
    }
  }

  onBlurSalesmanId() {
    if (this.salesmanIdForm.valid) {
      this.saveSummaryStep();
    }
  }

  updateReferState() {
    this.toggleReferControlState('waiveLoadInd', this.premiumInfo.loadAmount > 0);
    this.toggleReferControlState('waiveExcessInd', this.premiumInfo.excessAmount > 0); //AGIC-49887
  }

  toggleReferControlState(controlName: string, condition: boolean) {
    const control = this.referCaseForm.get(controlName);
    condition ? control.enable() : control.disable();
  }

  updateRemarksValidator() {
    const waiveLoadInd = this.referCaseForm.get('waiveLoadInd').value;
    const waiveExcessInd = this.referCaseForm.get('waiveExcessInd').value;
    const underwritingInd = this.referCaseForm.get('underwritingInd').value;

    if (waiveLoadInd || waiveExcessInd || underwritingInd) {
      this.referCaseForm.get('remarks').setValidators([Validators.required]);
    } else {
      this.referCaseForm.get('remarks').clearValidators();
    }
    this.referCaseForm.get('remarks').updateValueAndValidity();
  }

  subscribeToCheckboxChanges() {
    this.referCaseForm.get('waiveLoadInd').valueChanges.subscribe(() => this.updateRemarksValidator());
    this.referCaseForm.get('waiveExcessInd').valueChanges.subscribe(() => this.updateRemarksValidator());
    this.referCaseForm.get('underwritingInd').valueChanges.subscribe(() => this.updateRemarksValidator());
  }

  showComponents() {
    if (this.isIssuance) {
      const cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote);
      this.showAgentInfo = this.showIssuanceInfo = this.showCustomerPartner =
        this.showCoverage = this.showHistoricalClaim =
        this.showPremiumInformation = this.showReferCase = true;

        if (this.userInfo.callCenter) {
          this.showPaymentDetails = true;
          this.showPaymentInformation = true;
          this.showPayment = true;
          this.showRoadTaxPayable = true;
          this.showUpsellProduct = true;
        }
        if (cngeNote && cngeNote.mkagAgent) {

          let mkagAgent = cngeNote.mkagAgent;
          this.showReferralDetails = mkagAgent.channel === "AG" || mkagAgent.sundriesAgent;
          this.showSalesmanID = mkagAgent.enableSalesmanId;
        }
    }

    if (this.isRTP) {
      this.showEditButton = false;
      this.showAgentInfo = true;
      this.showIssuanceInfo = true;
      this.showCustomerPartner = true;
      this.showCoverage = true;
      this.showHistoricalClaim = true;
      this.showPremiumInformation = true;
    } else if(this.isUpdatePayment) {
      this.showEditButton = false;
    }

    if (this.isEndorsement) {
      this.showAgentInfo = true;
      this.showIssuanceInfo = true;
      this.showCustomerPartner = true;
      this.showCoverage = true;
      this.showHistoricalClaim = true;
      this.showPremiumInformation = true;
      this.showChecklist = true; //endorsement only
      this.showEndorsementNarration = true; //endorsement only
      this.showPayment = true; //endorsement only
    }
  }

  componentDialogRef?: NxModalRef<SummaryPopupComponent>;

  openPopup(popup_type: any) {

    this.componentDialogRef = this.dialogService.open(SummaryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { popup_type: popup_type },
    });
    this.componentDialogRef.afterClosed().subscribe(res=>{
      if(this.closePopupAction != ''){
        this.updateEinvoiceConsentInd(true);
        this.store.dispatch(new SET_EINVOICE_CONSENT_IND(true)).subscribe(state=>{
          if(this.closePopupAction == 'generateEquotation'){
            this.generate();
          }
          if(this.closePopupAction == 'sendToJPJ'){
            this.sendToJPJ();
          }
          this.closePopupAction='';
        })
      }
    })
  }


  openPopupOCC(popup_type: any) {
    this.componentDialogRef = this.dialogService.open(SummaryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      height: '500px',
      data: { popup_type: popup_type },
    });
  }

  warningPopup(popup_type: any, error: any) {
    this.warningPopupModal = this.dialogService.open(WarningPopupComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
  }

  goToIssueDeclaration() {
    this.saveSummaryStep();

    this.router.navigate(['issuance/declaration-issuance-info'], {
      queryParamsHandling: 'preserve',
    });

  }

  goToCPScreen() {
    this.saveSummaryStep();

    this.router.navigate(['issuance/customer-partner'], {
      queryParamsHandling: 'preserve',
    });
  }

  goToCoverageScreen() {
    this.saveSummaryStep();

    this.router.navigate(['issuance/coverage'], {
      queryParamsHandling: 'preserve',
    });
  }

  openPopupOneAllianz(showNonEligibleMessage) {
    this.oneAllianzModal = this.dialogService.open(OneAllianzMessageComponent, {
      showCloseIcon: false,
      disableClose: true,
      width: "400px",
      maxWidth: "400px",
      data: {
        showNonEligible: showNonEligibleMessage
      }
    });
    this.oneAllianzModal.afterClosed().subscribe((result) => {
      this.store.dispatch(new STORE_SHOWED_ONE_ALLIANZ_POP_UP(true));
      if (this.effectiveDateMessage) {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: this.effectiveDateMessage
          }
        });
        this.store.dispatch(new RESET_SUMMARY_MESSAGE());
      }
    });
  }

  validateReferral() {
    if (this.referralForm.invalid) {
      this.referralForm.markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
    }

    return this.referralForm.valid;
  }

  validateReferCase() {
    const underwritingIndControl = this.referCaseForm.get('underwritingInd');
    const remarksControl = this.referCaseForm.get('remarks');

    if (underwritingIndControl?.value) {
      remarksControl?.setValidators([Validators.required]);
    } else {
      remarksControl?.clearValidators();
    }
    remarksControl?.updateValueAndValidity();

    if (this.referCaseForm.invalid) {
      console.log("referCaseForm invalid!");
      this.referCaseForm.markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
    }

    return this.referCaseForm.valid;
  }

  validatePayment() {
    if(!this.paymentList || this.paymentList.length === 0) {
      this.simpleModal = this.dialogService.open(SimpleModalComponent, {
        disableClose: true,
        width: '400px',
        data: {
          type: "Warning",
          message: "Please at least add one payment."
        }
      });
      return false;
    }else {
      return true;
    }
  }

  scrollToFirstInvalidControl(form: FormGroup) {
    const firstInvalidControl: HTMLElement = document.querySelector('form .ng-invalid');
    if (firstInvalidControl) {
      firstInvalidControl.focus();
      firstInvalidControl.scrollIntoView({ behavior: 'instant', block: 'center' });
    }
  }

  validateRenewalAssistance() {
    if (this.renewalAssistanceForm.invalid) {
      console.log("renewalAssistanceForm invalid!");
      this.renewalAssistanceForm.markAllAsTouched();
    } else {
      console.log("renewalAssistanceForm valid...");
    }

    return this.renewalAssistanceForm.valid;
  }

  generate() {
    
    let hasSendToJpj = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step4?.sendToJPJ);

    if(hasSendToJpj?.success){
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        disableClose: true,
        width: '400px',
        data: {
          message: "Record has been updated by someone. Please re-select the record again"
        }
      });
      return;
    }

    let custAge = this.cpData?.clientAge;
    let cpType = this.cpData?.idType1;
    let cnoteType = "";
    let updateQuotation = false;
    this.closePopupAction = '';
    const isEmarketingConsentEnabled = this.store.selectSnapshot(SatMotorState.isEmarketingConsentEnabled);
    const isEinvoice10kIndEnabled = this.store.selectSnapshot(SatMotorState.isEinvoice10kIndEnabled);
    
    if (this.isEndorsement) {
      cnoteType = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.generateQuotation?.cnoteStatus);
    } else {
      cnoteType = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.cnoteStatus);

      let isQuotationGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data?.proposalNo);
      let isCoverNoteGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ?.data?.cnoteNo);
      let isUpdateQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.updateQuotation);
      updateQuotation = isQuotationGenerated || isCoverNoteGenerated || isUpdateQuotation ? true : false;
    }

    let isFormValid = this.validateFormFields();
    const isCnoteStatusPrinted = cnoteType === "PRINTED";

    if (!isFormValid) {
      console.log("Form Validation Failed.");
      return;
    }

    let resetPayload = {};

    if (this.isRTP) {
      resetPayload = {
        isRTP: this.isRTP
      };
    } else if (this.isEndorsement) {
      resetPayload = {
        isEndorsement: this.isEndorsement
      };
    }

    //AGIC-46604 - Age checking
    if((custAge < 16 || custAge > 99) && (!this.isRTP) &&(cpType !=="NEW_BR_NO" && cpType !=="BR_NO")){
      this.openPopup("custAge");
    } else if (!this.isEInvoiceConsentSelected()) {
      this.openPopup("einvoiceEmpty");
    } else if (isEinvoice10kIndEnabled && !this.einvoiceConsentInd() && this.isGrossPremiumMoreThan10k()){
      this.closePopupAction='generateEquotation';
      this.openPopup("einvoiceConsentChange");
    } else if (isEmarketingConsentEnabled && !this.isEmarketingConsentSelected()){
      this.openPopup("emarketingEmpty");
    }else {
      if (!isCnoteStatusPrinted && !updateQuotation) {
        this.store.dispatch(new RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ(resetPayload));
      }

      this.store.dispatch(new SET_ERROR_FLAG({ code: 999 })).subscribe(() => { this.blocked = true; });
      let customerPartner = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step2);
      const emarketingConsentInd = this.store.selectSnapshot(SatMotorState.emarketingConsentInd);
      if(isEmarketingConsentEnabled && (emarketingConsentInd !== customerPartner?.emarketingConsentInd)){
        this.updateEmarketingConsent(customerPartner, emarketingConsentInd, null);
      }else{
        this.generateEquotation();
      }
    }
  }

  getPayloadData() {
    let payload = {
      userId: this.userInfo.userId,
      waiveLoadInd: this.referCaseForm.get('waiveLoadInd').value,
      waiveExcessInd: this.referCaseForm.get('waiveExcessInd').value,
      underwritingInd: this.referCaseForm.get('underwritingInd').value,
      agentReferId: this.referralForm.get('referralId').value,
      frStaffNo: this.salesmanIdForm.get('frStaffNo').value, 
      referRemarkList: null,
      isEndorsement: this.isEndorsement,
    };

    const referRemarkValue = this.referCaseForm.get('remarks').value;
    if (referRemarkValue) {
      payload = {
        ...payload,
        referRemarkList: [
          {
            referRemark: referRemarkValue,
            createdBy: this.userInfo.userId
          }
        ]
      };
    } else {
      delete payload.referRemarkList;
    }

    this.saveSummaryStep();
    return payload;
  }

  validateFormFields() {
    let isValidReferral = this.validateReferral();
    let isValidRemark = this.validateReferCase();
    let isValidRenewalAssistance = this.validateRenewalAssistance();

    return this.isRTP ? true : (isValidReferral && isValidRemark && isValidRenewalAssistance);
  }

  validateCCentricFormFields() {
    let isValidPayment = true;

    if(this.isCCentric && this.userInfo.callCenter && this.userInfo.callCentreType == "S") {
      isValidPayment = this.validatePayment();
    }
    return isValidPayment;
  }

  isEInvoiceConsentSelected() {
    let indicator = this.issuanceInfo?.pdpa?.consentDetails?.einvoiceConsentInd;
    return indicator === true || indicator === false;
  }

  isEmarketingConsentSelected() {
    let indicator = this.issuanceInfo?.pdpa?.consentDetails?.emarketingConsentInd;
    return indicator === true || indicator === false;
  }

  einvoiceConsentInd(){
    return this.issuanceInfo?.pdpa?.consentDetails?.einvoiceConsentInd;
  }

  isGrossPremiumMoreThan10k() {
    const einvoice10kTransAmount = this.store.selectSnapshot(SatMotorState.einvoice10kTransAmount);
    return (this.premiumInfo.grossPremium - this.premiumInfo.rebateAmt) > einvoice10kTransAmount;
  }

  checkORIXOverwiteBeforeSendJPJ(){
    if (this.eInvoiceConsentInd && this.coverageInfo.coverage.vehicleDetails.vehicleLoanType === "L" 
      && this.coverageInfo.coverage.vehicleDetails.vehicleLoanCompany === "ORIX" && this.dataORIXLeasingLov){
      const leasingCompanyItem = this.dataORIXLeasingLov?.find(item => item.companyCode === this.coverageInfo.coverage.vehicleDetails.leasingCompany);
      const messageBuyerOverwrite = "You have overwritten Buyer information from Policy Holder to " + leasingCompanyItem?.companyDesc
      + ". Kindly confirm. Click Yes to confirm and No to amend the details";
      const messagePolHolder = "Buyer's information is policy holder. Kindly confirm. Click Yes to confirm and No to amend the details";

      this.confirmMessageModal = this.dialogService.open(ConfirmationModalComponent, {
        showCloseIcon: false, width: "550px", maxWidth: "550px",
        disableClose: true,
        data: {
          message: this.coverageInfo.coverage.vehicleDetails.buyerOverwriteInd ? messageBuyerOverwrite : messagePolHolder,
        }
      });
      this.confirmMessageModal.afterClosed().subscribe(result => {
        if (result) { 
          this.sendToJPJ();
        } else {
          return;
        }
      });
    } else {
      this.sendToJPJ();
    }
  }

  sendToJPJ() {
    this.motorPC = this.store.selectSnapshot<any>((state)=>state.SatMotorState.motor.step1?.issuance?.issuance?.productCode);
    this.lovproductConfig = this.lov.productAccessConfigList;
    let address1 = this.cpData.clientPartnerAddress.clientAddress1Tmp?.trim();
    let emailValue = this.cpData.clientEmail?.trim();
    let cnoteStatus = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data?.cnoteStatus);
    let proposalNo = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data?.proposalNo);
    let custAge = this.cpData?.clientAge;
    let cpType = this.cpData?.idType1;
    let updateQuotation = false;
    this.closePopupAction = '';
    const isEmarketingConsentEnabled = this.store.selectSnapshot(SatMotorState.isEmarketingConsentEnabled);
    const isEinvoice10kIndEnabled = this.store.selectSnapshot(SatMotorState.isEinvoice10kIndEnabled);

    let hasSendToJpj;
    
    if (this.isRTP) {
      hasSendToJpj= this.store.selectSnapshot<any>(state => state.SatMotorState.rtp.step2?.sendToJPJ);
    } else {
      hasSendToJpj= this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step4?.sendToJPJ);
    }
    
    if (hasSendToJpj?.data?.cnoteNo && hasSendToJpj?.success) {
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        disableClose: true,
        width: '400px',
        data: {
          message: "Record has been updated by someone. Please re-select the record again"
        }
      });
      return;
    }
    
    if (!this.isRTP) {
      for (let i = 0; i < this.lovproductConfig.length; i++) {
        this.productAccessListData = this.lovproductConfig[i];
        this.lovPC = Object.keys( this.productAccessListData)[0]; 
      
          if (this.lovPC === this.motorPC) {
           this.emailCheck = this.productAccessListData[this.lovPC].emailCheckEnableSat;
          }
        }
    }

    if(( (!address1) && (!emailValue) ) && ( (this.edocConsentInd) || (this.emailCheck =="true") || (this.eInvoiceConsentInd) ) && (!this.isRTP) ){
      this.openPopup("addrEmailSum");
    }
    else if(((address1) && (!emailValue)) && ( (this.edocConsentInd) || (this.emailCheck =="true") || (this.eInvoiceConsentInd) ) &&((!this.isRTP)) ){
      this.openPopup("emailSum");
    }
    else if ( (!address1) && ((!this.isRTP)) ) {
      this.openPopup("address");
    }else if((custAge < 16 || custAge > 99) && (!this.isRTP) &&(cpType !=="NEW_BR_NO" && cpType !=="BR_NO")){
      this.openPopup("custAge");
    }else if(!this.isEInvoiceConsentSelected() && (!this.isRTP)){
      this.openPopup("einvoiceEmpty");
    }else if ((isEinvoice10kIndEnabled && !this.einvoiceConsentInd() && this.isGrossPremiumMoreThan10k()) && (!this.isRTP)){
      this.closePopupAction='sendToJPJ';
      this.openPopup("einvoiceConsentChange");
    }else if((isEmarketingConsentEnabled && !this.isEmarketingConsentSelected()) && (!this.isRTP)){
      this.openPopup("emarketingEmpty");
    }
    else {

      let isFormValid = false;

      if(this.isCCentric) {
        isFormValid = this.validateCCentricFormFields();
      }else {
        isFormValid = this.validateFormFields();
      }

      if (!isFormValid) {
        console.log("Form Validation Failed.");
        return;
      }

      let resetPayload = {};

      if(cnoteStatus === 'PRINTED' && proposalNo){
        //update quotation purpose
        resetPayload = {
          updateQuotation: true
        };
      }

      if (this.isRTP) {
        resetPayload = {
          isRTP: this.isRTP
        };
      } else if (this.isEndorsement) {
        resetPayload = {
          isEndorsement: this.isEndorsement
        };
      } else {
        let isQuotationGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data?.proposalNo);
        let isCoverNoteGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ?.data?.cnoteNo);
        let isUpdateQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.updateQuotation);
        updateQuotation = isQuotationGenerated || isCoverNoteGenerated || isUpdateQuotation ? true : false;
      }

      if (!updateQuotation) {
        this.store.dispatch(new RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ(resetPayload));
      }

      this.store.dispatch(new SET_ERROR_FLAG({ code: 999 })).subscribe(() => { this.blocked = true; });
      let customerPartner = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step2);
      const emarketingConsentInd = this.store.selectSnapshot(SatMotorState.emarketingConsentInd);
      if(isEmarketingConsentEnabled && (emarketingConsentInd !== customerPartner?.emarketingConsentInd)){
        this.updateEmarketingConsent(customerPartner, emarketingConsentInd, updateQuotation);
      }else{
        this.proceedSendToJPJ(updateQuotation);
      }
    }
  }

  showResponseError(response: any, payload) {

    console.log('showResponseError response:' + response);

    let message = (response.message && response.message != '') ? response.message : (response.errorCode && response.errorCode != '') ? response.errorCode : null;

    console.log('showResponseError message:' + message);

    if (message) {

      if (response.messageHeader) {
        let ncdInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.ncdInfo);
        if (!ncdInfo) {
          ncdInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3?.coverage?.ncdInfo);
        } 

        if (ncdInfo && ncdInfo.blockIssuanceInd) {
          this.okMessageModal = this.dialogService.open(OkMessageComponent, {
            disableClose: true,
            width: '400px',
            data: {
              message: ncdInfo.errMsg
            }
          });
        }
      } else {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: message
          }
        });
      }

    } 
    else if (response.messageConfirm && response.messageHeader) {
      this.showConfirmationMessage(response, payload);
    }
  }

  showConfirmationMessage(response, payload) {

    this.dialogService.open(MessagePromptModalComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "350px",
      maxWidth: "350px",
      data: { message: response.messageConfirm },
    })
    .afterClosed().subscribe(result => {
      if (result) {

        let summaryPremium = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step4?.summary?.coverageInfo?.coverage?.coveragePremium?.cngeNote);
        let coveragePremium = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step3.coverage.coveragePremium.cngeNote);
        let cngeNote = summaryPremium ? summaryPremium : coveragePremium;

        if (!cngeNote.skipErrorAndProceed) {

          let calcPremPayload = { 
            cngeNote: { 
              ...cngeNote, 
              skipErrorAndProceed: true,
              riskList: [{
                ...cngeNote.riskList[0],
                coverList: [{
                  ...cngeNote.riskList[0].coverList[0],
                  ncdPercentage: 0
                }]
              }]
            }, 
            operator: this.userInfo.userId
          };

          this.store.dispatch(new CALCULATE_PREMIUM_NCD(calcPremPayload)).subscribe(state => {
            this.router.navigate(['issuance/summary'], {
              queryParamsHandling: 'preserve',
            });
          });

        } else {

          let resendPayload = {
            ...payload,
            skipErrorAndProceed: true
          }
          if (!payload.updateQuotation) {
            this.store.dispatch(new RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ({}));
          }
          
          this.store.dispatch(new SET_ERROR_FLAG({ code: 999 })).subscribe(() => { this.blocked = true; });
          this.store.dispatch(new SEND_TO_JPJ(resendPayload))
          .pipe(
            catchError(e => {
              this.store.dispatch(new SET_ERROR_MESSAGE(e));
              this.dialogService.open(ErrorModalComponent, {
                disableClose: true,
                width: "400px",  data: { e: e },
              });
              return throwError(e);
            })
          )
          .subscribe(() => {
            this.store.dispatch(new RESET_ERROR_MESSAGE()).subscribe(() => { this.blocked = false; });
            let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ ?? null);
            if (response && response.data && response.success) {
              let contractId = response?.data?.contractId;
              if (contractId && response?.data?.cnoteStatus === 'PRINTED') {
                this.downloadPDF(contractId, 'covernote');
              }
  
              this.store.dispatch(new SET_JPJ_STATUS_SENT(true));
  
              this.router.navigate(['issuance/complete'], {
                queryParamsHandling: 'preserve',
              });
            } else {
              this.showResponseError(response, payload);
            }
          });
        }
      }
    });
  }

  renewalAssistanceWarningMessage(popup_type: any, error: any) {
    this.warningPopupModal = this.dialogService.open(WarningPopupComponent, {
      showCloseIcon: false,  width: "600px", maxWidth: "600px",
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
  
    this.warningPopupModal.afterClosed().subscribe(result => {
      if (result) {
        if (result === 'Y') {
          this.renewalAssistanceForm.controls.creditCardType.setValue("");
          this.renewalAssistanceForm.controls.creditCardNo.setValue("");
          this.renewalAssistanceForm.controls.creditCardExpMonth.setValue("");
          this.renewalAssistanceForm.controls.creditCardExpYear.setValue("");
          this.renewalAssistanceForm.controls.creditCardHolderName.setValue("");
          this.renewalAssistanceForm.controls.autoRenewalStartDt.setValue("");
          this.renewalAssistanceForm.controls.termsOfUse.setValue(null);
          this.renewalAssistanceCheckbox = false;
          this.renewalAssistanceForm.markAsUntouched();
        }else{
          this.renewalAssistanceForm.controls.autoRenewalInd.setValue(true);
          this.renewalAssistanceForm.controls.termsOfUse.setValue(true);
          this.renewalAssistanceCheckbox = true;
        }
        this.saveSummaryStep();
      }
    });
  }

  downloadPDF(contractId, type) {
    let payload = {
      operator: this.userInfo.userId,
      contractId: contractId,
      type: type
    };

    this.store.dispatch(new DOWNLOAD_PDF(payload)).subscribe(() => {
      this.router.navigate(['issuance/complete'], {
        queryParamsHandling: 'preserve',
      });
    });

  }

  onChangeRenewalAssistanceForm(fieldName: any, value: any) {
    console.log('onChangeValue..' + value.checked);
    
    if(value){
      this.renewalAssistanceCheckbox = true;
      this.renewalAssistanceForm.controls.autoRenewalInd.setValue(true);
      this.renewalAssistanceForm.controls.termsOfUse.setValue(true);
      this.saveSummaryStep();
    }else{
      this.renewalAssistanceWarningMessage("warningPopupThree","This will remove Auto Renewal details. Click OK to continue.");
    }


    if (fieldName == 'autoRenewalInd') {
      this.renewalAssistanceForm.controls.creditCardType.clearValidators();
      this.renewalAssistanceForm.controls.creditCardNo.clearValidators();
      this.renewalAssistanceForm.controls.creditCardExpMonth.clearValidators();
      this.renewalAssistanceForm.controls.creditCardExpYear.clearValidators();
      this.renewalAssistanceForm.controls.creditCardHolderName.clearValidators();
      this.renewalAssistanceForm.controls.autoRenewalStartDt.clearValidators();
      this.renewalAssistanceForm.controls.termsOfUse.clearValidators();
      if (value) {
        this.renewalAssistanceForm.controls.creditCardType.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardNo.setValidators([Validators.required, Validators.pattern(/^\d{16}$/)]);
        this.renewalAssistanceForm.controls.creditCardExpMonth.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardExpYear.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardHolderName.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.autoRenewalStartDt.setValidators([Validators.required]);
        this.renewalAssistanceForm.controls.termsOfUse.setValidators([Validators.required]);
      } else {
        this.renewalAssistanceForm.controls.creditCardType.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardNo.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardExpMonth.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardExpYear.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.creditCardHolderName.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.autoRenewalStartDt.removeValidators([Validators.required]);
        this.renewalAssistanceForm.controls.termsOfUse.removeValidators([Validators.required]);
      }
      this.updateRenewalAssistanceValueAndValidity();
    }
  }

  onDateChange(event: any) {
    this.saveSummaryStep();
  }

  populateRenewalAssistanceForm(){
    if(this.renewalAssistanceDetails){

      this.renewalAssistanceForm.patchValue({ 
        ...this.renewalAssistanceDetails,
      });

      this.renewalAssistanceForm.updateValueAndValidity();
  
      if (this.renewalAssistanceDetails?.autoRenewalInd) {
        this.renewalAssistanceCheckbox = true;
      }
    }
    
  }

  updateRenewalAssistanceValueAndValidity(){
    this.renewalAssistanceForm.controls.creditCardType.updateValueAndValidity();
    this.renewalAssistanceForm.controls.creditCardNo.updateValueAndValidity();
    this.renewalAssistanceForm.controls.creditCardExpMonth.updateValueAndValidity();
    this.renewalAssistanceForm.controls.creditCardExpYear.updateValueAndValidity();
    this.renewalAssistanceForm.controls.creditCardHolderName.updateValueAndValidity();
    this.renewalAssistanceForm.controls.autoRenewalStartDt.updateValueAndValidity();
    this.renewalAssistanceForm.controls.termsOfUse.updateValueAndValidity();
  }

  uploadDocument() {

    const productCode = this.store.selectSnapshot<any>((state)=>state.SatMotorState.motor.step1?.issuance?.issuance?.productCode);

    let contractId = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step1?.issuance?.issuance?.contractId);
    if (!contractId)
      contractId = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step3?.contractId);
    if (!contractId)
      contractId = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step4?.generateQuotation?.contractId);
    if (!contractId)
      contractId = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step5?.cngeNote?.contractId);

    let dialogConfig = {
      showCloseIcon: false,
      disableClose: true,
      width: "80%",
      maxWidth: "80vw",
      maxHeight: "95vh",
      data: {
        productCode: productCode,
        contractId: contractId
      }
    };

    this.dialogRef = this.dialogService.open(UploadDocumentComponent, dialogConfig); 
  }

  goBack() {    
          if (this.isRTP) {
            this.router.navigate(['issuance/declaration-issuance-info']);
          }
      
          if (this.isIssuance) {
            this.router.navigate(['issuance/coverage']);
          }
      
          if (this.isEndorsement) {
            this.router.navigate(['endorsement/endorsement-details']);
          }
  }

  updatePaymentList(paymentList) {
    this.paymentList = paymentList;
    this.onChangePaymentSection();
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  getPaymentData(data) {
    let cngeNotePremiumInfo = data?.coverageInfo?.coverage?.coveragePremium?.cngeNote ?? this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage?.coveragePremium?.cngeNote);
    
    if (cngeNotePremiumInfo) {
      this.payment = {
        ...data?.payment,
        accountCode: this.agentData.agentCode,
        insuredName: this.cpData.clientName,
        totalPremiumDue: this.premiumInfo.premiumDue,
        vehicleNo: cngeNotePremiumInfo?.riskList?.[0]?.vehicleNo,
        eCoverNoteNo: cngeNotePremiumInfo?.cnoteNo,
        transactionDate: cngeNotePremiumInfo?.receiptDate,
        receiptNo: cngeNotePremiumInfo?.receiptNo
      };

      this.paymentList = [
        ...cngeNotePremiumInfo?.paymentList ?? []
      ];

      this.roadTaxPayable = {
        roadTax: cngeNotePremiumInfo.roadTax,
        myegFees: cngeNotePremiumInfo.myegFees,
        courierFees: cngeNotePremiumInfo.courierFees,
        merchantCharges: cngeNotePremiumInfo.merchantCharges,
        totalRoadTaxPayable: cngeNotePremiumInfo.totalRoadTaxPayable
      };

      this.paymentInformation = {
        totalPayable: cngeNotePremiumInfo.totalPayable,
        totalPayableRounded: cngeNotePremiumInfo.totalPayableRounded,
        totalPaid: cngeNotePremiumInfo.totalPaid,
        balancePayable: cngeNotePremiumInfo.balancePayable
      };
    }
  }

  onChangePaymentSection() {
    let summaryPremium = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step4?.summary?.coverageInfo?.coverage?.coveragePremium?.cngeNote);
    let coveragePremium = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step3.coverage.coveragePremium.cngeNote);
    let cngeNote = summaryPremium ? summaryPremium : coveragePremium;
    if(this.summaryForm.get('roadTaxPayableForm')) {
      let roadTaxPayableForm = this.summaryForm.get('roadTaxPayableForm');
      cngeNote = {
        ...cngeNote,
        ...roadTaxPayableForm.getRawValue(),
        roadTax: this.numberFmt.transform(roadTaxPayableForm.get('roadTax').value),
        myegFees: this.numberFmt.transform(roadTaxPayableForm.get('myegFees').value),
        merchantCharges:this.numberFmt.transform(roadTaxPayableForm.get('merchantCharges').value),
        courierFees: roadTaxPayableForm.get('courierFees').value ? 6.00 : 0.00,
      };
    }

    cngeNote.paymentList = this.paymentList ? this.paymentList : [];

    let payload = {
      cngeNote: cngeNote,
      operator: this.userInfo.userId
    };

    this.store.dispatch(new ISSUANCE_CALCULATE_PREMIUM_SUMMARY(payload)).subscribe(state => {
      let premiumSummaryResponse = state.SatMotorState?.motor?.step4?.summary?.coverageInfo?.coverage?.coveragePremium?.cngeNote;
      let coveragePremium = state.SatMotorState?.motor?.step4?.summary?.coverageInfo?.coverage?.coveragePremium;
      this.coverageInfo = {
        ...this.coverageInfo,
        coverage: {
          ...this.coverageInfo.coverage,
          coveragePremium: coveragePremium
        },
      };
      
      let roadTaxPayableResponse = {
        roadTax: premiumSummaryResponse.roadTax,
        myegFees: premiumSummaryResponse.myegFees,
        courierFees: premiumSummaryResponse.courierFees,
        merchantCharges: premiumSummaryResponse.merchantCharges,
        totalRoadTaxPayable: premiumSummaryResponse.totalRoadTaxPayable
      };
      this.roadTaxPayable = roadTaxPayableResponse;
      this.store.dispatch(new STORE_ROAD_TAX_PAYABLE({isEndorsement: this.isEndorsement, roadTaxPayable: roadTaxPayableResponse}));

      this.paymentInformation = {
        totalPayable: premiumSummaryResponse.totalPayable,
        totalPayableRounded: premiumSummaryResponse.totalPayableRounded,
        totalPaid: premiumSummaryResponse.totalPaid,
        balancePayable: premiumSummaryResponse.balancePayable
      };
      this.store.dispatch(new STORE_PAYMENT_INFO({isEndorsement: this.isEndorsement, paymentInfo: this.paymentInformation}));
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    });
    
  }

  savePayment() {
    let cnoteType = "";
    
    if (this.isEndorsement) {
      cnoteType = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.generateQuotation?.cnoteStatus);
    } else {
      cnoteType = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.cnoteStatus);
    }

    const isCnoteStatusPrinted = cnoteType === "PRINTED";

    let payload = this.getPayloadData();

    let resetPayload = {};

    this.store.dispatch(new SAVE_PAYMENT(payload)).subscribe(() => { //need to check for endorsement
      let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.updatePayment ?? null);
      console.log(response);

      if (response && response.data && response.data.contractId && response.success) {
        let contractId = response?.data?.contractId;

        if (response?.data?.cnoteStatus === 'PRINTED') {
          this.downloadPDF(contractId, 'covernote');
        }

        this.router.navigate(['issuance/complete'], {
          queryParamsHandling: 'preserve',
        });

      } else {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: response.message
          }
        });
      }
    });
  }

  disableRenewalAssistanceForm(){
    this.renewalAssistanceForm.controls.creditCardType.disable();
    this.renewalAssistanceForm.controls.creditCardNo.disable();
    this.renewalAssistanceForm.controls.creditCardExpMonth.disable();
    this.renewalAssistanceForm.controls.creditCardExpYear.disable();
    this.renewalAssistanceForm.controls.creditCardHolderName.disable();
    this.renewalAssistanceForm.controls.autoRenewalStartDt.disable();
    this.renewalAssistanceForm.controls.termsOfUse.disable();
  }

  updatePaymentDisableField() {
    this.referralForm.disable();
    this.referCaseForm.disable();
    this.salesmanIdForm.disable();
  }

  isCalculateAge() {
    return this.isIssuance ? true : false;
  }

  get isRSEUser() {
    if(this.userInfo.callCenter && this.userInfo.callCentreType == "T") {
      return true;
    }else {
      return false;
    }
  }

  get isSSUser() {
    if(this.userInfo.callCenter && this.userInfo.callCentreType == "S") {
      return true;
    }else {
      return false;
    }
  }

  isMotorcycle() {
    return ["082100", "082101"].includes(this.issuanceInfo.issuance.productCode);
  }

  isDisableSendToJPJ() {

    if (this.blocked)
      return true;

    if (this.isRTP) {
      return false;
    } else {
      return this.validateAccess(AccessConfig.SEND_TO_JPJ);
    }
  }

  isDisableUpload() {

    if (this.blocked)
      return true;
    return false;
    
  }

  isDisableUpdatePayment(): boolean {
    return this.validateAccess(AccessConfig.UPDATE_PAYMENT);
  }

  isDisableGenerateButton() {
    if (this.blocked)
      return true;

    return this.validateAccess(AccessConfig.UPDATE_QUOTATION);
  }

  validateAccess(config: ButtonAccessConfig): boolean {
    return this.accessService.checkAccess(config);
  }
  generateEquotation(){
    let payload = this.getPayloadData();
    this.store.dispatch(new GENERATE_QUOTATION(payload, this.cnoteType))
    .pipe(
      catchError(e => {
        this.store.dispatch(new SET_ERROR_MESSAGE(e));
        this.dialogService.open(ErrorModalComponent, {
          disableClose: true,
          width: "400px",  data: { e: e },
        });
        return throwError(e);
      })
    )
    .subscribe(() => { //need to check for endorsement
      this.store.dispatch(new RESET_ERROR_MESSAGE()).subscribe(() => { this.blocked = false; });
      let response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation ?? null);
      console.log(response);
      if (response && response.data && response.data.contractId && response.success) {
        let contractId = response?.data?.contractId;
        if (response?.data?.cnoteStatus === 'PRINTED') {
          this.downloadPDF(contractId, 'quotation');
        }
        this.store.dispatch(new RESET_DRAFT_DETAILS());
        this.router.navigate(['issuance/complete'], {
          queryParamsHandling: 'preserve',
        });
      } else {
        this.okMessageModal = this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: '400px',
          data: {
            message: response.message
          }
        });
      }
    });
  }

  proceedSendToJPJ(updateQuotation){
    let payload = this.getPayloadData() as any;
    payload = {
      ...payload,
      isRTP: this.isRTP,
      isEndorsement: this.isEndorsement,
      cnoteType: this.cnoteType,
      updateQuotation
    };
    this.store.dispatch(new SEND_TO_JPJ(payload))
      .pipe(
        catchError(e => {
          this.store.dispatch(new SET_ERROR_MESSAGE(e));
          this.dialogService.open(ErrorModalComponent, {
            disableClose: true,
            width: "400px",  data: { e: e },
          });
          return throwError(e);
        })
      )
      .subscribe(() => {
        this.store.dispatch(new RESET_ERROR_MESSAGE()).subscribe(() => { this.blocked = false; });
        let response;
        if (this.isRTP) {
          response = this.store.selectSnapshot<any>(state => state.SatMotorState.rtp?.step2?.sendToJPJ ?? null);
          if (response && response.data && response.data.cngeNoteDto.contractId) {
            let contractId = response?.data?.cngeNoteDto?.contractId;

            this.router.navigate(['issuance/complete'], {
              queryParamsHandling: 'preserve',
            });
          } else {
            this.showResponseError(response, payload);
          }
        } else if (this.isEndorsement) {
          response = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.sendToJPJ ?? null);
          console.log('SEND_TO_JPJ response:' + response);

          if (response && response.data && response.data.cngeNoteDto) {
            let contractId = response?.data?.cngeNoteDto?.contractId;

            this.router.navigate(['endorsement/complete'], {
              queryParamsHandling: 'preserve',
            });
          } else {
            this.showResponseError(response, payload);
          }
        } else {
          response = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ ?? null);
          if (response && response.data && response.success) {
            let contractId = response?.data?.contractId;
            if (contractId && response?.data?.cnoteStatus === 'PRINTED') {
              this.downloadPDF(contractId, 'covernote');
            }

            this.store.dispatch(new SET_JPJ_STATUS_SENT(true));

            this.store.dispatch(new RESET_DRAFT_DETAILS());

            this.router.navigate(['issuance/complete'], {
              queryParamsHandling: 'preserve',
            });
          } else {
            this.showResponseError(response, payload);
          }
        }
      });
  }

  updateEmarketingConsent(clientPartner, emarketingConsentInd, updateQuotation){
    const date = new Date();
    const mkagAgent = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1.agentDetail);
    const effectiveDate = moment(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`, 'YYYY-M-D').format('YYYY-MM-DD');
    const userId = this.store.selectSnapshot<string>((state) => state.UserState.user.userId);
    clientPartner ={
      ...clientPartner,
      emarketingConsentInd: emarketingConsentInd
    }
    const payload ={
      clientPartner,
      mkagAgent,
      effectiveDate: effectiveDate,
      productType: 'MT',
      operator: userId
    }
    this.store.dispatch(new EDIT_CUSTOMER_PARTNER(payload)).subscribe(res => {
      if(updateQuotation != null){
        this.proceedSendToJPJ(updateQuotation);
      } else{
        this.generateEquotation();
      }
    });
  }

  updateEinvoiceConsentInd(einvoiceConsentInd){
    this.issuanceInfo = {
      ...this.issuanceInfo, 
      pdpa:{
        ...this.issuanceInfo.pdpa,
        consentDetails:{
          ...this.issuanceInfo.pdpa.consentDetails,
          einvoiceConsentInd: einvoiceConsentInd
        }
      }
    }
  }

}


